import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/common/img-pagetop.svg'


const _withScopeId = n => (_pushScopeId("data-v-05068948"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "l-wrapper" }
const _hoisted_2 = { class: "l-wrapper_main" }
const _hoisted_3 = { class: "p-login" }
const _hoisted_4 = { class: "p-login-inner" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "p-login-heading-1" }, "パスワード更新", -1))
const _hoisted_6 = ["onSubmit"]
const _hoisted_7 = { class: "p-login-form__field" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-login-form__label",
  for: "current-password"
}, "現在のパスワード", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "p-login-form__toggle js-toggle-password",
  type: "button"
}, null, -1))
const _hoisted_10 = { class: "p-login-form__field" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-login-form__label",
  for: "new-password"
}, "新しいパスワード（英数字含む8文字以上）", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "p-login-form__toggle js-toggle-password",
  type: "button"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-login-form__field" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "p-login-button",
    type: "submit"
  }, "変更する")
], -1))
const _hoisted_14 = { class: "l-wrapper_nav" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"p-recommend-form__modal-card -is-complete\" data-v-05068948><a class=\"p-recommend-form__modal-help-close js-modal-close-trigger\" href=\"/login/\" data-v-05068948>閉じる</a><p class=\"p-recommend-form__text-7\" data-v-05068948>パスワード変更完了</p><a class=\"p-recommend-form__modal-help-close-2\" href=\"/login/\" data-v-05068948>ログイン画面へ</a></div><div class=\"p-recommend-form__modal-close-area\" data-v-05068948></div>", 2)
const _hoisted_20 = [
  _hoisted_18
]

import Loading from '@/components/Loading.vue';
import { postPasswordEdit } from '@/api/profileEndpoint';
import { ref } from 'vue';
import { isValidPassWordAllowed, isValidPassWord, isValidRequired, isValidMaxLength } from '@/plugins/validation';
import { errorMessage } from '@/constants/validationErrors';
import { domHelperUtils } from '@/utils/domHelper';

import { onMounted } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'PwupdateView',
  setup(__props) {

const isLoading = ref(false);
const isModalActive = ref(false);
let isErrorPasswordInput = ref(false);
let passwordErrorMessage = ref('');
let isErrorNewPasswordInput = ref(false);
let newPasswordErrorMessage = ref('');
let isErrorPassword = ref(false);
let ErrorMessage = ref('');

function scrollToTop() {
  domHelperUtils.scrollToTop();
}

const pwupdateAction = async () => {
  isErrorPasswordInput.value = false;
  isErrorNewPasswordInput.value = false;
  isErrorPassword.value = false;

  isLoading.value = true;

  // 現在のパスワードの入力値を取得
  const currentPasswordInput = document.getElementById('current-password');
  const currentPasswordValue = currentPasswordInput ? currentPasswordInput.value : '';

  // 新しいパスワードの入力値を取得
  const newPasswordInput = document.getElementById('new-password');
  const newPasswordValue = newPasswordInput ? newPasswordInput.value : '';

  // 入力チェック

  // 現在のパスワードは50文字以下で入力してください。
  if (!isValidMaxLength(currentPasswordValue, 50)) {
    isErrorPasswordInput.value = true;
    passwordErrorMessage.value = errorMessage('MAX_LENGTH', { label: '現在のパスワード',  max: '50' });
  }
  
  // 英数字含む8文字以上であること
  if (!isValidPassWord(newPasswordValue)) {
    isErrorNewPasswordInput.value = true;
    newPasswordErrorMessage.value = errorMessage('PASSWORD_RULE', { label: '新しいパスワード' });
  }

  // 新しいパスワードは50文字以下で入力してください。
  if (!isValidMaxLength(newPasswordValue, 50)) {
    isErrorNewPasswordInput.value = true;
    newPasswordErrorMessage.value = errorMessage('MAX_LENGTH', { label: '新しいパスワード',  max: '50' });
  }

  // パスワードの利用可能文字チェック
  // 半角英数字・記号（! @ # $ % ^ & * ( ) _ + - = [ ] { } | '）以外は利用できない
  if (!isValidPassWordAllowed(newPasswordValue)) {
    isErrorNewPasswordInput.value = true;
    newPasswordErrorMessage.value = errorMessage('PASSWORD_ALLOWED', { label: '新しいパスワード' });
  }

  // 必須チェック
  if (currentPasswordValue === '' || newPasswordValue === '') {
    if (!isValidRequired(currentPasswordValue)) {
      isErrorPasswordInput.value = true;
      passwordErrorMessage.value = errorMessage('REQUIRED', { label: '現在のパスワード' });
    }
    if (!isValidRequired(newPasswordValue)) {
      isErrorNewPasswordInput.value = true;
      newPasswordErrorMessage.value = errorMessage('REQUIRED', { label: '新しいパスワード' });
    }
  }

  if (isErrorPasswordInput.value || isErrorNewPasswordInput.value) {
    isLoading.value = false;
    return;
  }

  try {
    await postPasswordEdit({
      password: currentPasswordValue,
      newPassword: newPasswordValue,
    });
    isModalActive.value = true;
  } catch (error) {
    console.error(error);
    let args = (error as { response: { data: { errorDetail: { globalError: { args: string[] }[] } } } }).response.data.errorDetail.globalError[0]
      .args || [];
    let code = (error as { response: { data: { errorDetail: { globalError: { args: string[] }[] } } } }).response.data.errorDetail.globalError[0]
      .code || [];
    if (code === 'EB001') {
      isErrorPassword.value = true;
      ErrorMessage.value = args[0];
      isLoading.value = false;
      return;
    }
    if (code === 'EB002') {
      isErrorPasswordInput.value = true;
      passwordErrorMessage.value = args[0];
      isLoading.value = false;
      return;
    }
  } finally {
    isLoading.value = false;
  }
};

function showPassword() {
  const toggleButtons = document.querySelectorAll('.js-toggle-password');
  toggleButtons.forEach((toggleButton) => {
    toggleButton.addEventListener('click', function(e) {
      e.preventDefault();
      const passwordField = toggleButton.parentElement?.querySelector('.js-password-field');
      if (passwordField) {
        if (passwordField.type === 'password') {
          passwordField.type = 'text';
          toggleButton.classList.add('--is-visible');
        } else {
          passwordField.type = 'password';
          toggleButton.classList.remove('--is-visible');
        }
      }
    });
  });
}

onMounted(() => {
  showPassword();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("main", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("form", {
              class: "p-login-form",
              onSubmit: _withModifiers(pwupdateAction, ["prevent"])
            }, [
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("p", { class: "p-login-form__error" }, _toDisplayString(_unref(passwordErrorMessage)), 513), [
                  [_vShow, _unref(isErrorPasswordInput)]
                ]),
                _hoisted_8,
                _createElementVNode("input", {
                  class: _normalizeClass(["p-login-form__text --is-password js-password-field", { '--is-error': _unref(isErrorPasswordInput) }]),
                  id: "current-password",
                  maxlength: "50",
                  type: "password",
                  name: "current-password",
                  placeholder: "パスワード（半角英数字）"
                }, null, 2),
                _hoisted_9
              ]),
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("p", { class: "p-login-form__error" }, _toDisplayString(_unref(newPasswordErrorMessage)), 513), [
                  [_vShow, _unref(isErrorNewPasswordInput)]
                ]),
                _hoisted_11,
                _createElementVNode("input", {
                  class: _normalizeClass(["p-login-form__text --is-password js-password-field", { '--is-error': _unref(isErrorNewPasswordInput) }]),
                  id: "new-password",
                  maxlength: "50",
                  type: "password",
                  name: "new-password",
                  placeholder: "パスワード（半角英数字）"
                }, null, 2),
                _hoisted_12
              ]),
              _withDirectives(_createElementVNode("p", { class: "p-login-form__error" }, _toDisplayString(_unref(ErrorMessage)), 513), [
                [_vShow, _unref(isErrorPassword)]
              ]),
              _hoisted_13
            ], 40, _hoisted_6)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("a", {
          class: "g-pagetop",
          href: "#",
          "aria-label": "ページトップへ戻る",
          onClick: _withModifiers(scrollToTop, ["prevent"])
        }, _hoisted_17, 8, _hoisted_15)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["p-recommend-form__modal js-modal-container", { 'is-active': isModalActive.value }])
    }, _hoisted_20, 2),
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"])
  ], 64))
}
}

})